import _ from 'lodash';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectFeeTypeMismo = createSelector(getSystem, ({ feeTypeMismo }) => feeTypeMismo);

export const selectFeeTypeMismoOptions = createSelector(selectFeeTypeMismo, feeTypes =>
  _.map(feeTypes, value => ({ name: _.startCase(value).replace('Item 203 K', '203K'), value })),
);
